import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate } from 'libs/router'
import { FieldValues, UseFormSetError } from 'react-hook-form'
import { apiRoutes } from 'config/apiRoutes'

export const useChangePasswordMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const navigate = useNavigate()

	const { mutate: changePasswordMutation, isPending: changePasswordIsLoading } = useMutation({
		mutationFn: (data) => {
			return axiosPrivate.post(apiRoutes.meChangePassword, data)
		},
		onSuccess: () => {
			useToast({ type: 'success', message: t('Password changed') })()
			navigate('/profile')
		},
		onError: (res: any) => {
			if (res?.response?.data) {
				for (const [key, value] of Object.entries(res.response.data)) {
					setError(key, { message: value as string })
				}
			}

			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		changePasswordMutation,
		changePasswordIsLoading
	}
}
